export default __webpack_public_path__ + "static/media/stamp.a4055fd9.svg";